import { ReactElement } from 'react';
import { Formik } from 'formik';
import {
    AppFormikPasswordField,
    AppPrimaryButton,
} from 'shared/components/AppComponents';
import { Box, Grid, Typography } from '@mui/material';
import { Toast, Utils } from 'shared/helpers';
import { UserSettingService } from 'services/UserSettingService';
import { changePasswordScheme } from 'validators/ChangePasswordSchema';

const ChangePassword = (): ReactElement => {
    const changePasswordForm = {
        newPassword: '',
        currentPassword: '',
        confirmPassword: '',
    };

    // API Calls
    const changePassword = (values: any, callback: any): void => {
        const formValue = { ...values };
        delete formValue.confirmPassword;
        UserSettingService.changePassword(formValue)
            .then((response: any) => {
                Utils.handleSuccessResponse(response);
                callback(true);
            })
            .catch((error: any) => {
                callback(false);
                Utils.handleErrorResponse(error);
            });
    };

    // UI Actions
    const actionOnFormSubmit = (formValues: any, formik: any): void => {
        const { currentPassword, newPassword } = formValues;
        if (currentPassword === newPassword) {
            Toast.showErrorMessage(
                'Sorry you have entered current password as a new password'
            );
            formik.setSubmitting(false);
            formik.resetForm();
        } else {
            changePassword(formValues, (status: any) => {
                formik.setSubmitting(false);
                if (status) {
                    formik.resetForm();
                }
            });
        }
    };

    // UI Elements
    return (
        <Box className="pb-10">
            <Box className="app-box-wrapper">
                <Box className="app-box-header flex-column">
                    <Typography className="title-left">
                        Change your password
                    </Typography>

                    <Typography className="subtitle mt-2">
                        Minimum requirements: 8 characters (Uppercase,
                        Lowercase, Number and Special Character)
                    </Typography>
                </Box>

                <Box className="app-box-content p-8">
                    <Formik
                        enableReinitialize
                        initialValues={changePasswordForm}
                        validationSchema={changePasswordScheme}
                        validateOnMount
                        onSubmit={(formValues, formik) => {
                            actionOnFormSubmit(formValues, formik);
                        }}
                    >
                        {({ handleSubmit, isSubmitting, isValid }) => (
                            <form autoComplete="off">
                                <Grid
                                    container
                                    spacing={5}
                                    className="justify-center"
                                >
                                    <Grid item xs={3}>
                                        <AppFormikPasswordField
                                            outerLabel
                                            label="Current Password"
                                            name="currentPassword"
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <AppFormikPasswordField
                                            outerLabel
                                            label="New Password"
                                            name="newPassword"
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <AppFormikPasswordField
                                            outerLabel
                                            label="Confirm Password"
                                            name="confirmPassword"
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xs={3}
                                        className="align-start mt-8"
                                    >
                                        <AppPrimaryButton
                                            fullWidth
                                            title="Change"
                                            isLoading={isSubmitting}
                                            loadingSize={22}
                                            loadingText="SAVING"
                                            disabled={isSubmitting || !isValid}
                                            onClick={handleSubmit}
                                            className="poppins-semi-bold"
                                        />
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Box>
            </Box>
        </Box>
    );
};

export default ChangePassword;
